import React, { useRef, useState } from 'react';
import useOutsideClickHandler from 'utils/useOutsideClickHandler';
import { SelectProps } from 'views/Questions/components/Select/Select.types';
import { SubjectType } from 'shared/constants/subjects.types';
import { GradeType } from 'shared/constants/grades.types';
import styles from './Select.module.css';

const Select = ({
  children,
  options,
  onClick,
  classNameLabel,
  classNameOptions,
}: SelectProps) => {
  const selectRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);

  const isSubjectType = (i: Record<string, unknown>): i is SubjectType =>
    i['name'] !== undefined;
  const isGradeType = (i: Record<string, unknown>): i is GradeType =>
    i?.['label'] !== undefined;

  const selectItemHandler = (i: SubjectType | GradeType) => {
    onClick(i);
    setShowOptions(false);
  };

  useOutsideClickHandler(selectRef, () => setShowOptions(false));

  return (
    <div ref={selectRef} className={styles.select}>
      <div className={classNameLabel} onClick={() => setShowOptions(!showOptions)}>
        {children}
      </div>
      {showOptions && (
        <div className={`${styles.select__options} ${classNameOptions}`}>
          {options.map((i) => (
            <div
              onClick={() => selectItemHandler(i)}
              key={isGradeType(i) ? i.label : i.name}
              className={styles.select__option}
            >
              {isGradeType(i)
                ? i.label
                : isSubjectType(i)
                ? i.name.replace(/[-]/g, '')
                : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
